<template>
  <div>
    <Dialog :key="changeEmailFormKey"  header="Change Email" :visible.sync="changeEmailForm1"  :modal="true" class="p-fluid" :style="{ width: '500px' }">
        <Message severity="info" :closable="false">Ensure that the email address entered is correct and working, otherwise the user will not be able to receive email notifications or password reset emails.</Message>
        <div>
            <div class="row align-items-center justify-content-center">
                 <div class="col-6">
                     <div class="p-field">
                        <label for="email">Current Email</label>
                        <InputText
                            id="email"
                            v-model.trim="userToEdit.email"
                            required="true"
                            type="email"
                            disabled="true"
                        />
                     </div>    
                 </div>
            </div>
            <div class="row align-items-center justify-content-center">
                 <div class="col-6">
                     <div class="p-field">
                        <label for="email">New Email</label>
                        <InputText
                                id="email"
                                v-model.trim="newEmail"
                                required="true"
                                type="email"
                                autofocus
                                :class="{ 'p-invalid': submitted && !newEmail }"
                            />
                            <small class="p-invalid" v-if="submitted && !newEmail"
                                >Email is required.</small
                            ><br/>
                            <small class="p-invalid" v-if="invalidNewEmail"
                                >Email must be valid.</small
                            ><br/>
                            <small class="p-invalid" v-if="newEmailNotMatch"
                                >Email don't match.</small
                            >
                        </div> 
                 </div>
            </div>
            <div class="row align-items-center justify-content-center">
                 <div class="col-6">
                     <div class="p-field">
                        <label for="email">Confirm Email</label>
                        <InputText
                                id="email"
                                v-model.trim="confirmEmail"
                                required="true"
                                type="email"
                                autofocus
                                :class="{ 'p-invalid': submitted && !confirmEmail }"
                            />
                            <small class="p-invalid" v-if="submitted && !confirmEmail"
                                >Email is required.</small
                            ><br/>
                            <small class="p-invalid" v-if="invalidConfirmEmail"
                                >Email must be valid.</small
                            >
                        </div>
                     </div>    
                 </div>
            </div>

    <template #footer>
        <Button 
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="$emit('close')" 
        />
        <ProgressSpinner 
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;" 
          strokeWidth="5" 
          fill="#EEEEEE" 
          animationDuration=".5s"
        />
        <Button 
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="save"
        />
    </template>
    </Dialog>

  </div>
</template>

<script>

import UserService from "@/service/UserService";

import { changeEmail } from '../sendRequest'

export default {
  created() {
      this.submitted = false
      this.sendingRequest = false
  },
  props: {
    changeEmailForm: {
      required: true,
      type: Boolean
    },
    userToEdit: {
      type: Object,
      required: false,
      default: () => {{}}
    }
  },
   data() {
      return {
        user: this.userToEdit,
        userService: new UserService(),
        submitted: false,
        sendingRequest: false,
        changeEmailFormKey1: 0,
        invalidNewEmail: false,
        invalidConfirmEmail: false,
        newEmailNotMatch: false,
        newEmail: '',
        confirmEmail: ''
      }
    },
   watch: {
    changeEmailForm(val) {
      this.changeEmailFormKey = this.changeEmailFormKey1 + 1
    },
   }, 
  computed: {
    changeEmailFormKey: {
      set(val) {
        this.changeEmailFormKey1++
      },
      get() {
        return 'changeEmailFormKey-' + this.changeEmailFormKey1.toString()
      }
    },
    changeEmailForm1: {
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      },
      get() {
        return this.changeEmailForm
      }
    }
  },
  methods: {
    validateEmail(val) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let a = re.test(String(val).toLowerCase())
      return a
    },
    save() {
    this.submitted = true

    if(this.newEmail && !this.validateEmail(this.newEmail)) { this.invalidNewEmail = true; } else { this.invalidNewEmail = false; }
    if(this.confirmEmail && !this.validateEmail(this.confirmEmail)) { this.invalidConfirmEmail = true; } else { this.invalidConfirmEmail = false; }
    if(this.newEmail !== this.confirmEmail) {this.newEmailNotMatch = true; } else {this.newEmailNotMatch = false; }
    if(!this.invalidNewEmail && !this.invalidConfirmEmail && !this.newEmailNotMatch) 
    {
      changeEmail(this, 'ChangeEmailForm.vue')
      this.sendingRequest = true
    }
    },
  }
}
</script>

<style scoped>
.row:hover {
    background-color: white;
}
</style>